<template>
  <div class="box-content">
     <div>
      <arrorImg bg="white"></arrorImg>
    <navBar title="意见反馈" color="#ffffff"></navBar>
    <span class="request-title">反馈类型</span>
    <div class="suggest-title">
      <span @click="changeSuggest(3)" :class="feedbackType == 3 ? 'active' : ''"
        >问题反馈</span
      >
      <div @click="changeSuggest(1)" :class="feedbackType == 1 ? 'active' : ''">
        <span>产品建议</span>
        <img src="../../../static/rember-icon.png" alt="" />
      </div>
    </div>
    <textarea
      class="uni-textarea-class"
      v-model="content"
      placeholder-style="color:#AAAAAA;"
      placeholder="输入您的反馈详情,100字以内哦~"
    />
    <span class="tips" v-if="feedbackType == 1"
      >建议一经采纳，将获得书币，会员，现金红包等奖励</span
    >
    <span class="connect-title">联系方式</span>
    <input
      class="connect-input"
      type="text"
      v-model="contact"
      placeholder="请输入您的手机号"
    />
    <span class="upload-title">添加图片 （选填，最多选三张）</span>
    <div class="image-content">
      <div
        class="upload-image"
        @click="chooseImage"
        v-if="uploadFile.length < 3"
      >
        <input
         id="upload_file" type="file" class="file-input" 
          v-show="false"
          @change="changeImg"
          ref="file"
          accept="image/*"
          :multiple="3"
        />
        <img src="../../../static/check_city.png" alt="" />
      </div>
      <div v-for="(item, index) in uploadFile" class="image-list" :key="index">
        <img
          class="delete-icon"
          @click="deleteImage(index)"
          src="../../../static/activity_close.png"
          alt=""
        />
        <img class="image-item" :src="item" alt="" />
      </div>
    </div>
     </div>
    <div class="pay-btn" @click="submit">
      <span>提交</span>
    </div>
    <div class="bottom-code" v-if="CsQrCodeUrl">
      <div>
          <div>
            <img :src="CsQrCodeUrl" alt="">
          </div>
         <p>长按添加人工客服<br>立即处理问题</p>
      </div>

    </div>
  </div>
</template>
<script>
import { Toast, MessageBox, Field } from "mint-ui";
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
export default {
  components: {
    arrorImg,
    navBar,
  },
  data() {
    return {
      feedbackType: 3,
      imgList: [],
      content: "",
      contact: "",
      uploadFile: [],
      pageType: "",
      isEntranceData: "",
      CsQrCodeUrl:''
    };
  },
  mounted() {
    if (this.$route.query.feedbackType) {
      this.feedbackType = this.$route.query.feedbackType;
    }
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }

    this.pageType = this.$route.query.pageType;
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
    	 var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录
    } else if (isWxAuthorized==0 &&city==1&& openid && !this.$store.state.user.isSNS) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.insertPageAccessData();
      this.getCsQrCodeUrl()
    } else {
      this.insertPageAccessData();
      this.getCsQrCodeUrl()
    }
    this.$commonApi.share();
  },
  methods: {
    getCsQrCodeUrl(){
      this.$api.getCsQrCodeUrl().then((res) => {
             if(res.status==1){
              this.CsQrCodeUrl=res.data
             }
      })
    },
    insertPageAccessData() {
      var pageType = "";
      if (this.pageType == "bookMine") {
        pageType = "我的";
      } else if (this.pageType == "bookCharge") {
        pageType = "充值中心";
      } else if (this.pageType == "bookRember") {
        pageType = "会员中心";
      } else if (this.pageType == "bookCity") {
        pageType = "书城";
      }
      var params = {
        pageName: "意见反馈",
        pageRemark: "上级页面：" + pageType,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    changeSuggest(index) {
      this.feedbackType = index;
    },
    chooseImage() {
        document.getElementById("upload_file").click();
    },
    changeImg() {
      // 上传图片事件
      var files = this.$refs.file.files[0];
      console.log(files);
      var formData = new FormData();
          formData.append('file',files)
      this.$api.uploadPhoto(formData).then((res) => {
        if (res.status == 1) {
          let img = res.data[0];
          this.uploadFile.push(img);
        } else {
          Toast(res.message);
        }
        document.getElementById("upload_file").value = "";
      });
    },
    deleteImage(index) {
      this.uploadFile.splice(index, 1);
    },
    submit() {
      var content = this.content.replace(/\s*/g, "");
      if (content == "") {
        Toast({
          message: "内容不能为空",
        });
        return;
      }
      if (this.contact == "") {
        Toast({
          message: "联系方式不能为空",
        });
        return;
      }
      if (/^1[34578]\d{9}$/.test(this.contact)) {
        this.feedback();
      } else {
        Toast({
          message: "手机号错误，请重新输入",
        });
      }
    },
    feedback() {
      var params = {
        content: this.content,
        contact: this.contact,
        imgUrl: this.uploadFile.join(","),
        feedbackType: this.feedbackType,
      };
      this.$api.feedbackSubmit(params).then((res) => {
        if (res.status == 1) {
          Toast({
            message: res.message,
          });
          this.$router.go(-1);
        } else {
          Toast({
            message: res.message,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.box-content {
  padding-top: 16px;
  box-sizing: border-box;
  /* padding-bottom: 60px; */
}
.box-content>div{
  padding:0px 16px;
}
.request-title {
  font-size: 14px;
  color: #312c28;
  margin-bottom: 12px;
  display: block;
  font-weight: bold;
  margin-top: calc(44px + env(safe-area-inset-top));
}

.suggest-title {
  display: flex;
}

.suggest-title > span,
.suggest-title > div {
  display: block;
  border: 1px solid #aaaaaa;
  border-radius: 4px;
  height: 40px;
  line-height: 40px;
  width: 48%;
  font-size: 14px;
  color: #666666;
  text-align: center;
  position: relative;
}

.suggest-title > span.active,
.suggest-title > div.active {
  color: #ffffff;
  background-color: #de3b34;
  border: 1px solid #de3b34;
}
.suggest-title > div img {
  width: 40px;
  height: 16px;
  position: absolute;
  right: 0px;
  top: 0px;
}

.suggest-title > span:nth-child(1) {
  margin-right: 4%;
}
.uni-textarea-class {
  background-color: #f3f3f3;
  border-radius: 4px;
  height: 144px;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  margin-top: 16px;
  margin-bottom: 12px;
  font-size: 12px;
  border: none;
  height: 130px;
}

.tips {
  font-size: 12px;
  color: #de3b34;
  display: block;
  margin-bottom: 20px;
}

.connect-title {
  font-size: 14px;
  color: #312c28;
  font-weight: bold;
  display: block;
}

.connect-input {
  height: 40px;
  background-color: #f3f3f3;
  border-radius: 4px;
  font-size: 12px;
  padding: 5px;
  box-sizing: border-box;
  margin-top: 15px;
  border: none;
  width: 100%;
}

.upload-title {
  font-size: 14px;
  color: #312c28;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 15px;
  display: block;
}

.pay-btn {
  /* position: fixed;
  bottom: 0px; */
  background-color: #de3b34;
  color: #ffffff;
  width: 100%;
  /* height: 44px; */
  text-align: center;
  line-height: 44px;
  /* left:0; */
  margin-top:20px;
  box-sizing: border-box;

}
.pay-btn>span{
  font-size:14px;
}
.upload-image {
  width: 80px;
  height: 80px;
  border: 1px dashed #cccccc;
  text-align: center;
  border-radius: 4px;
  margin-right: 10px;
}

.upload-image img {
  width: 30px;
  height: 30px;
  margin-top: 25px;
}
.image-list {
  position: relative;
  margin-right: 10px;
}
.image-list .image-item {
  width: 80px;
  height: 80px;
}
.delete-icon {
  position: absolute;
  width: 20px;
  height: 20px;
  right: -10px;
  top: -10px;
  z-index: 99;
}
.image-content {
  display: flex;
}

.image-content > span {
  margin-right: 10px;
}
.box-content>.bottom-code{
  padding: 20px 16px;
}
.bottom-code>div{
  width: 328px;
height: 212px;
background: #E0F2FF;
border-radius: 10px;
text-align: center;
padding:20px 0px;
box-sizing: border-box;

}
.bottom-code>div>div{
  width: 128px;
height: 128px;
background: #FDFDFD;
box-shadow: 0px 2px 4px 0px rgba(98,98,98,0.5);
border-radius: 8px;margin:0 auto;
}
.bottom-code>div>div img{
  width: 108px;
  height: 108px;
  margin-top: 10px;
}
.bottom-code>div>p{
  font-size: 12px;
color: #868383;
margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/bookFeedback/index.vue